module.exports = __webpack_public_path__ + "65f0087b100d866352071385599e1fab.png";